import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing, space } = theme.busbud;

  return {
    button: {
      // Compensation shifts for visual alignment
      // relative to the `CheckpointPath` icon and vertical text line.
      marginTop: spacing(`-${space.component.button.sizeSm.inset.iconRight.y}`),
      marginLeft: spacing(
        `-${space.component.button.sizeSm.inset.iconRight.left}`
      )
    }
  };
});
